import React from 'react';
import PropTypes from 'prop-types';

function Icon(props) {
  return (
    <span
      className={`fa ${props.name}`}
      aria-hidden="true"
      {...props}
    >
    </span>
  );
}
Icon.propTypes = {
  name: PropTypes.any,
};
export default Icon;



// WEBPACK FOOTER //
// ./app/components/Icon/index.js